export default __webpack_public_path__ + "public/images/home/intro/greenStar.png?20820ba8";